import { useCallback } from 'react';
import { QueryKey } from '@tanstack/react-query';
import { modalIds } from 'components/modal/Modal.constants';
import useAppModal from 'hooks/useAppModal';
import { Integration } from 'models/InternalIntegrationSetting';
import EnrollmentModal from './EnrollmentModal';

interface OpenEnrollmentModalParams {
  integration: Integration;
  queryKey: QueryKey;
}

const useEnrollmentModal = () => {
  const { openModal } = useAppModal();

  const open = useCallback(
    ({ integration, queryKey }: OpenEnrollmentModalParams) =>
      openModal({
        id: modalIds.hostfullyAccountingEnrollment,
        customContent: (
          <EnrollmentModal
            modalId={modalIds.hostfullyAccountingEnrollment}
            integration={integration}
            queryKey={queryKey}
          />
        ),
      }),
    [openModal],
  );

  return { open };
};

export default useEnrollmentModal;
